<template>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label>Restaurant</label>
                <multiselect v-model="selectedRestaurant" deselect-label="Can't remove this value" :allow-empty="false" :options="restaurants" label="name" track-by="name" @input="fetchBranchesOfRestaurant()"></multiselect>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>Branches</label>
                <multiselect id="filter2" v-model="selectedBranch" deselect-label="Can't remove this value" :allow-empty="false" :options="branches" :custom-label="opt=> opt.areasByAreaId.name" track-by="id" @input="fetchBranchMenu()"></multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import User from '@/services/User'
    import Multiselect from 'vue-multiselect';
    export default {
      name: "ResturantBranches",
      data(){
          return {
                restaurants: [],
                selectedRestaurant: "",
                selectedBranch: "",
                selectedTable: "",
                branches: [],
                menu: [],
                itemOptions:[],
                allMenuItems:[],
        }
      },
      props: {
        notFetchMenu: {
          type: Boolean,
          default: false,
        }
      },
      components: {Multiselect},
        created() {
            User.fetchUserRoles().then(role => {
                if(role === 'ROLE_ADMIN' || role === 'ROLE_AGENT'){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                        this.restaurants = resp.data;
                        this.$parent.restaurants= resp.data;
                    });
                }else if(role === 'ROLE_USER' || role === 'ROLE_FRANCHISE'){
                    this.selectedRestaurant = this.$store.state.user.restaurant;
                    this.$parent.selectedRestaurant= this.$store.state.user.restaurant;
                    this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
                    this.fetchBranchesOfRestaurant();
                }else if(role === 'ROLE_BRANCH'){
                    this.selectedRestaurant = this.$store.state.user.restaurant;
                    this.$parent.selectedRestaurant= this.$store.state.user.restaurant;
                    this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
                    this.$parent.selectedBranch= this.$store.state.user.branch;
                    this.selectedBranch= this.$store.state.user.branch;
                    this.branches.push(this.$store.state.user.branch);
                    this.fetchBranchMenu();
                }
            });
        },
        methods:{
            fetchBranchesOfRestaurant: function () { //fetch all the branches of current selected resturant
                this.selectedTable= "";
                this.$parent.branchTables="";
                this.$parent.selectedBranch=[];
                let params = new URLSearchParams();
                params.append("restaurant_id", this.selectedRestaurant.id);
                if(this.selectedRestaurant !== ""){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                        this.branches = resp.data;
                        this.$parent.branches= resp.data;
                    });
                }else{
                    this.branches = [];
                }
                this.selectedBranch = "";
                this.menu = []
            },
            fetchBranchMenu: function () { //fetch menu of selected branch
              this.$parent.selectedBranch= this.selectedBranch;
              if (this.notFetchMenu) return;
                this.isHideSpinner = "";
                this.menu = [];
                let params3 = new URLSearchParams();
                if(this.selectedBranch === ""){
                    this.isHideSpinner = "hide";
                   return;
                }
                params3.append("branch_id", this.selectedBranch.id);
                this.$parent.fetchBranchTables();
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_branch_menu", params3).then(resp => {
                    this.menu = resp.data;
                    this.$parent.menu= resp.data;
                    this.isHideSpinner = "hide";
                    // this.$parent.fetchBranchTables();
                    this.menu.forEach((mCategory) => {
                        mCategory.menuItemsById.forEach((menuItem) => { //prepare array of menu items to show on the top serach of menu item
                            this.allMenuItems.push(menuItem);
                            menuItem.menuItemTypesById.forEach((menuItemType) => {
                                 let option = { menuItem:menuItem ,menuItemType: menuItemType, itemName: menuItem.name , serving: menuItemType.serving, categoryName:mCategory.name};
                                 this.itemOptions.push(option);
                            })
                        })
                    });
                    this.$parent.itemOptions= this.itemOptions;
                }).catch(ex => {
                    this.isHideSpinner = "hide";
                    swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
                });
            },
        }
    }
</script>

<style scoped>
.col-md-6{
    padding-right: 4px !important;
    padding-left: 4px !important;
}
</style>
